import { render, staticRenderFns } from "./FlexLayout.vue?vue&type=template&id=265684b7&"
import script from "./FlexLayout.vue?vue&type=script&lang=js&"
export * from "./FlexLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports